import React from "react";
import MetricTrendCard from "../end-customer-ecosystem/MetricTrendCard";
import { MetricTrendCardData } from "../../types";

interface PerformanceTrendSectionProps {
  metrics: MetricTrendCardData[];
  isStaticDisabled?: boolean;
}

const PerformanceTrendSection: React.FC<PerformanceTrendSectionProps> = ({
  metrics,
  isStaticDisabled = false,
}) => {
  return (
    <section
      className={`performance-trend-section${
        isStaticDisabled ? " performance-trend-section--static-disabled" : ""
      }`}
    >
      <div className="performance-trend-section__header">
        <h3 className="performance-trend-section__title">Performance Trend</h3>
        <p className="performance-trend-section__subtitle">
          Track users, licenses, and end-customer growth over time
        </p>
      </div>
      <div className="performance-trend-section__metrics">
        {metrics.map((metric) => (
          <MetricTrendCard
            key={metric.id}
            data={metric}
            isStaticDisabled={isStaticDisabled}
          />
        ))}
      </div>
    </section>
  );
};

export default PerformanceTrendSection;
